import styled from 'styled-components';
import CloseIcon from 'assets/images/close-24.svg';

const ModalCloseIcon = styled.img.attrs({
  src: CloseIcon
})`
  float: right;
  &:hover {
    cursor: pointer;
  }
`;

const ModalTitle = styled.div`
  clear: both;
  text-align: left;
  font-size: 24px;
  margin-bottom: 20px;
`;

const ModalText = styled.div`
  text-align: left;
  font-size: 18px;
  margin-bottom: 30px;
`;

const ModalCancel = styled.a`
  cursor: pointer;
  font-family: 'HelveticaNeue', 'Helvetica Neue';
  font-size: 1em;
  font-weight: 500;
  text-align: left;
  color: ${(p) => p.theme.color.error};
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  left: 0;
`;

const ModalButtonBack = styled.button`
  cursor: pointer;
  border: 0;
  padding: 0.72em 2.5em;
  font-family: 'HelveticaNeue', 'Helvetica Neue';
  font-size: 1em;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  border-radius: 4px;
  background-color: ${(p) => p.theme.color.primary};
  margin-right: 0.938em;
`;

const ModalLine = styled.div`
  margin-top: 20px;
  height: 1px;
  background-color: ${props => props.theme.color.border};
  margin: 0px -15px 15px -30px;
`;

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(58, 61, 77, 0.5)',
    zIndex: 10
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '15px 15px 15px 30px',
    width: '27em'
  }
};

export {
  ModalCloseIcon,
  ModalTitle,
  ModalText,
  ModalCancel,
  ModalButtonBack,
  ModalLine,
  customStyles
};
